import { FC, ReactNode } from 'react';

import { FloatingTabs } from '@dbt-labs/sourdough';

import { useQueryParamOption } from '@/hooks/queryParamOption';
import { buildTypePredicate } from '@/util/type';

interface PanelTabsProps {
  children: (tabType: TabType) => ReactNode;
}

const tabTypes = ['general'] as const;
type TabType = (typeof tabTypes)[number];

type TabInfo = {
  type: TabType;
  count?: number;
};

const tabNameMap: Record<TabType, string> = {
  general: 'General',
};

const isTabType = buildTypePredicate(tabTypes);

const getTabType = (input: string | undefined | null): TabType | null => {
  return isTabType(input) ? input : null;
};

export const ColumnPanelTabs: FC<PanelTabsProps> = (props: PanelTabsProps) => {
  const { children } = props;
  const [tabParam, setTabParam] = useQueryParamOption({
    param: 'tab',
    options: tabTypes,
    validateOption: getTabType,
  });

  const tabs: TabInfo[] = [{ type: 'general' }];

  const activeTab = tabParam ? { type: tabParam } : tabs[0];

  return (
    // TODO: the whole block below could be a component
    // `<PanelFloatingTabs tabs={tabs} activeTab={activeTab} setTabParam={setTabParam} />`
    // that can be re-used for any type of panel with floating tabs
    <div>
      <div className="overflow-x-auto">
        <FloatingTabs>
          {tabs.map((tabDetails) => (
            <FloatingTabs.Tab
              key={tabNameMap[tabDetails.type]}
              text={tabNameMap[tabDetails.type]}
              id={tabDetails.type}
              isActive={activeTab.type === tabDetails.type}
              onClick={(tab: TabType) => {
                setTabParam(tab);
              }}
              count={tabDetails.count}
            />
          ))}
        </FloatingTabs>
      </div>

      <>{activeTab.type && <div>{children(activeTab.type)}</div>}</>
    </div>
  );
};
